import jobStatus from "../../../shared/variables/job-status";
import {
  FETCH_COURSES,
  FETCH_COURSES_SUCCESS,
  FETCH_COURSES_FAILED,
  FETCH_COURSES_RECENT_SCORES_FAILED,
  FETCH_COURSES_RECENT_SCORES_SUCCESS,
} from "../actions";

const initialState = {
  courses: [],
  fetchCoursesStatus: jobStatus.NOT_STARTED,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_COURSES:
      return {
        ...state,
        courses: [],
        fetchCoursesStatus: jobStatus.PROCESSING,
      };
    case FETCH_COURSES_SUCCESS:
      return {
        ...state,
        courses: payload,
        fetchCoursesStatus: jobStatus.SUCCESS,
      };
    case FETCH_COURSES_FAILED:
      return {
        ...state,
        fetchCoursesStatus: jobStatus.FAILED,
      };
    case FETCH_COURSES_RECENT_SCORES_FAILED:
      return {
        ...state,
        fetchCoursesStatus: jobStatus.FAILED,
      };
    case FETCH_COURSES_RECENT_SCORES_SUCCESS:
      return {
        ...state,
        courses: payload,
        fetchCoursesStatus: jobStatus.FAILED,
      };
    default:
      return state;
  }
};
